module.exports = __webpack_public_path__ + "40e53d90d00f50f5e718cfdad0a33586.pdf";